import { Component, ChangeDetectorRef } from "@angular/core";
import { Platform, ToastController } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { AuthenticationService } from "./services/authguard/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UpdateService } from "./services/update/update.service";
import { FCM } from "cordova-plugin-fcm-with-dependecy-updated/ionic";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "./services/language/language.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { ApiService } from "./services/http/api.service";
import { ApiConfiguration } from "./services/http/api-configuration";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  language_key: any;
  selectedPlatform: any = "mobile";
  isSmallScreen: boolean;
  private readonly mobileQuery: MediaQueryList;
  token: string;
  uid: string;
  localDetail: any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private updateService: UpdateService,
    private transLateService: TranslateService,
    private languageService: LanguageService,
    private toastController: ToastController,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) {
    this.localDetail = JSON.parse(localStorage.getItem("login-details"));
    this.initializeApp();
    this.languageService.setInitialAppLanguage();

    this.mobileQuery = media.matchMedia("(max-width: 720px)");
    this.isSmallScreen = this.mobileQuery.matches;

    this.mobileQuery.addEventListener("change", () => {
      changeDetectorRef.detectChanges();
      this.isSmallScreen = this.mobileQuery.matches;
    });
  }

  initializeApp() {
    window.localStorage.setItem("brand_name", "Bigcity");
    this.platform.ready().then(() => {
      this.route.queryParams.subscribe((params) => {
        console.log(params, "hellrererewrwerewrewr");
        if (params.token && params.uid) {
          this.token = params.token;
          this.uid = params.uid;
          localStorage.setItem("auth-token", "Bearer "+params.token);
          localStorage.setItem("uid", params.uid);
          this.getUserProfile();
        } else {
          // localStorage.setItem("uid", 'P1234');
          // this.uid = 'P1234'
          // this.getUserProfile();
        }
      });

      // check for updates
      if (this.platform.is("mobile")) {
        this.selectedPlatform = "mobile";
      } else {
        this.selectedPlatform = "browser";
      }
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.splashScreen.hide();
      // this.checkAndRedirect();

      if (this.platform.is("cordova")) {
        FCM.getToken()
          .then((token) => {
            localStorage.setItem("fcm", token);
          })
          .catch((err) => {
            // console.log('err:::', err)
          });

        FCM.onNotification().subscribe((data) => {
          if (data.wasTapped) {
            // console.log("Received in background");
          } else {
            // console.log("Received in foreground");
            this.pushLocalNotification(data);
          }
        });

        FCM.onTokenRefresh().subscribe((token) => {
          // backend.registerToken(token);

          // console.log('refresh token', token)
          localStorage.setItem("fcm", token);
        });

        FCM.hasPermission().then((hasPermission) => {
          if (hasPermission) {
            // console.log("Has permission!");
          } else {
            // console.log('No permission')
            FCM.requestPushPermission().then(
              (res) => {
                // console.log("Permission accepted")
              },
              (err) => {
                // console.log("Permission rejected")
              },
            );
          }
        });
        FCM.clearAllNotifications();
      }

      this.statusBar.backgroundColorByHexString("#1A1A1A");
    });
    this.platform.resume.subscribe(async () => {
      //Check for updates
      if (this.platform.is("mobile")) {
        // this.updateService.descideUpdateAction();
      }
    });
    this.callTranslationEvent();
  }
  getUserProfile() {
    this.apiService
      .get(this.apiConfig.profilePage + `?program_id=1&user_id=${this.uid}`)
      .subscribe(
        (res: any) => {
          console.log(res);
          localStorage.setItem(
            "login-details",
            JSON.stringify(res.data.user_details),
          );
          if(res.data.user_details.contact_updated == 1){
                      localStorage.setItem("uid", res.data.user_details.uid);
            this.token = res.data.user_details.sso_token;
              this.authenticationService.login(this.token).then((resonse) => {
                this.router.navigate(["/tabs-page/dashboard"]);
              });
          }else{
            this.router.navigate(["/onboarding/lava-enrollment"]);
          }
        },
        (err: any) => {},
      );
  }

  async checkAndRedirect() {
    let state = await this.authenticationService.isAuthenticated();
    //console.log(state);
  }

  pushLocalNotification(data) {
    console.log("notification data::", data);
    this.presentToastWithOptions(data);
  }

  async presentToastWithOptions(data) {
    const toast = await this.toastController.create({
      header: "V-Scan",
      message: data.body,
      position: "top",
      cssClass: "notification-alert",
      duration: 5000,
      buttons: [
        {
          side: "end",
          // icon: 'star',
          cssClass: "notification-button",
          text: "VIEW",
          handler: () => {
            this.router.navigateByUrl("/tabs-page/dashboard/notification");
          },
        },
      ],
    });
    toast.present();
  }

  callTranslationEvent() {
    this.transLateService.setDefaultLang("en");
    this.languageService.$changeLanguage.subscribe((lang) => {
      this.language_key = lang;
      //console.log("change Language = ", this.language_key);
      if (
        this.language_key["type"] == "language" &&
        this.language_key["data"] == "en"
      ) {
        this.transLateService.use(this.language_key["data"]);
      } else if (
        this.language_key["type"] == "language" &&
        this.language_key["data"] == "tm"
      ) {
        this.transLateService.use(this.language_key["data"]);
      }
    });
  }
}
